import { useCustom } from "@refinedev/core";
import { ProductDefinition } from "@/types";

export function useGetProducts() {
  const { data, isLoading, error, refetch } = useCustom<ProductDefinition[]>({
    url: "api/subscriptions/products",
    method: "get",
    queryOptions: {
      staleTime: 1000 * 60 * 10, // 10 minutes cache
    },
  });

  return {
    products: data?.data ?? [],
    isLoading,
    error,
    refetch,
  };
}
